import React from "react";
import FacturaList from "./FacturaList";

function FacturasPag() {
  return (
    <div className="container mt-4">
      <FacturaList />
    </div>
  );
}

export default FacturasPag;
